/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Delete_PermanentInputs */

const en_us2_profile_editors_delete_permanent = /** @type {(inputs: Profile_Editors_Delete_PermanentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is permanent.`)
};

const pt_br2_profile_editors_delete_permanent = /** @type {(inputs: Profile_Editors_Delete_PermanentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isso é permanente.`)
};

const es_419_profile_editors_delete_permanent = /** @type {(inputs: Profile_Editors_Delete_PermanentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto es permanente.`)
};

const pt_pt2_profile_editors_delete_permanent = /** @type {(inputs: Profile_Editors_Delete_PermanentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isto é permanente.`)
};

const fr_fr2_profile_editors_delete_permanent = /** @type {(inputs: Profile_Editors_Delete_PermanentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est définitif.`)
};

const de_de2_profile_editors_delete_permanent = /** @type {(inputs: Profile_Editors_Delete_PermanentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ist endgültig.`)
};

const it_it2_profile_editors_delete_permanent = /** @type {(inputs: Profile_Editors_Delete_PermanentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È definitivo.`)
};

/**
* | output |
* | --- |
* | "This is permanent." |
*
* @param {Profile_Editors_Delete_PermanentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_delete_permanent = /** @type {((inputs?: Profile_Editors_Delete_PermanentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Delete_PermanentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_delete_permanent(inputs)
	if (locale === "es-419") return es_419_profile_editors_delete_permanent(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_delete_permanent(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_delete_permanent(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_delete_permanent(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_delete_permanent(inputs)
	return en_us2_profile_editors_delete_permanent(inputs)
});
export { profile_editors_delete_permanent as "profile-editors.delete_permanent" }